/**
 * Проверяет, является ли URL запросом упаковки заказа без force_set
 * @param url - URL запроса
 * @returns true если это запрос packing без force_set
 */
export const isPackingRequestWithoutForce = (url: string): boolean => {
  return (
    url.includes('/admin/order/') &&
    url.includes('/packing') &&
    !url.includes('force_set=true')
  );
};
